const els = document.querySelectorAll('.js-share');

function share(el: HTMLElement) {
  const button = el.querySelector('.share__button'),
    dialog = el.querySelector<HTMLDialogElement>('.share__dialog');
  let isOpen = false;

  const toggleModal = () => {
    if (isOpen) dialog.close();
    else dialog.show();
    isOpen = !isOpen;
  };

  button.addEventListener('click', toggleModal);
}

els.forEach(share);
